$(document).ready(function(){
    

    $(".fourtly").click(function(){
 $("#ProductGridContainer").addClass("grid--4-col-desktop").removeClass("grid--3-col-desktop");
 $('.container-slides .flickity-viewport').removeClass('deskHeight');
 
});

 
$(".thirtly").click(function(){
 $("#ProductGridContainer").addClass("grid--3-col-desktop").removeClass("grid--4-col-desktop");
 $('.container-slides .flickity-viewport').addClass('deskHeight');



});


});

var header = document.getElementById("wasper");
var btns = header.getElementsByClassName("btn");
for (var i = 0; i < btns.length; i++) {
 btns[i].addEventListener("click", function() {
 var current = document.getElementsByClassName("actives");
 current[0].className = current[0].className.replace("actives", "");
 this.className += " actives";
 });
}